module.exports = __webpack_public_path__ + "static/media/icon-report.59988f34.svg";